import React, { useState } from 'react';
import { Avatar, Box, Container, Paper, Typography } from '@mui/material';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import Navbar from '../../Navbar';
import BarraFiltros from './components/BarraFiltros';
import TablaTerminales from './components/TablaTerminales';
import ModalCambiarModo from './components/ModalCambiarModo';
import useTerminales from './hooks/useTerminales';

const Terminales = () => {
  const [empresa, setEmpresa] = useState(1);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [terminalSeleccionada, setTerminalSeleccionada] = useState(null);

  const { data, total, loading, error, refetch, updateTerminalLocal } = useTerminales({
    empresa,
    page,
    pageSize,
  });

  const handleEmpresaChange = (nuevaEmpresa) => {
    setEmpresa(nuevaEmpresa);
    setPage(0);
  };

  const handlePageSizeChange = (newSize) => {
    setPageSize(newSize);
    setPage(0);
  };

  const handleModalClose = () => {
    setTerminalSeleccionada(null);
  };

  const handleModalSuccess = (updatedTerminal) => {
    updateTerminalLocal(updatedTerminal.id, updatedTerminal);
  };

  return (
    <>
      <Navbar />
      <Container maxWidth="xl" sx={{ mt: 2, mb: 4 }}>
        <Paper
          variant="outlined"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            p: 2,
            mb: 2,
            borderRadius: 2,
          }}
        >
          <Avatar sx={{ bgcolor: 'primary.main', width: 44, height: 44 }}>
            <PointOfSaleIcon />
          </Avatar>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
              Terminales Point
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Administrá el modo de operación de tus terminales de Mercado Pago
            </Typography>
          </Box>
        </Paper>

        <BarraFiltros
          empresa={empresa}
          onEmpresaChange={handleEmpresaChange}
          onRefresh={refetch}
          loading={loading}
          total={total}
        />

        <TablaTerminales
          data={data}
          total={total}
          loading={loading}
          error={error}
          page={page}
          pageSize={pageSize}
          onPageChange={setPage}
          onPageSizeChange={handlePageSizeChange}
          onConfigurar={setTerminalSeleccionada}
        />

        <ModalCambiarModo
          open={!!terminalSeleccionada}
          terminal={terminalSeleccionada}
          empresa={empresa}
          onClose={handleModalClose}
          onSuccess={handleModalSuccess}
        />
      </Container>
    </>
  );
};

export default Terminales;
